var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 3C51.1208 3 65 16.8792 65 34C65 51.1208 51.1208 65 34 65C16.8792 65 3 51.1208 3 34C3 16.8792 16.8792 3 34 3ZM44.8535 26.6465C44.6583 26.4512 44.3417 26.4512 44.1465 26.6465L30.5 40.293L23.8535 33.6465C23.6583 33.4512 23.3417 33.4512 23.1465 33.6465C22.9512 33.8417 22.9512 34.1583 23.1465 34.3535L30.1465 41.3535L30.2246 41.418C30.4187 41.5461 30.6827 41.5244 30.8535 41.3535L44.8535 27.3535C45.0488 27.1583 45.0488 26.8417 44.8535 26.6465Z",
    fill: "#0AB88A",
    stroke: "white",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedBadge);
export default __webpack_public_path__ + "static/media/verified-badge.2ae148142036fbaf21785a88eed3c877.svg";
export { ForwardRef as ReactComponent };